module.exports = __webpack_public_path__ + "img/glass-cocktail.39221ec6.svg";